import { CODE_TO_MESSAGE } from 'components/error'
import {
  authMiddleware,
  cacheMiddleware,
  RelayNetworkLayer,
  retryMiddleware,
  uploadMiddleware,
  urlMiddleware,
} from 'react-relay-network-modern'
import { Environment, RecordSource, Store } from 'relay-runtime'

const FETCH_TIMEOUT = 5000 // 5 seconds

const network = (getToken: () => Promise<string>) =>
  new RelayNetworkLayer([
    cacheMiddleware({
      size: 100, // max 100 requests
      ttl: 900000, // 15 minutes
    }),
    urlMiddleware({
      url: () => Promise.resolve('/api'),
    }),
    retryMiddleware({
      fetchTimeout: FETCH_TIMEOUT,
      retryDelays: (attempt) => Math.pow(2, attempt + 4) * 100,
      beforeRetry: ({ abort, attempt }) => {
        if (attempt > 3) {
          abort(CODE_TO_MESSAGE.RELAY_FETCH_FAILED)
        }
      },
      statusCodes: [500, 503, 504],
    }),
    authMiddleware({
      token: getToken,
    }),
    uploadMiddleware(),
  ])

const environment = (getToken: () => Promise<string>): Environment =>
  new Environment({
    network: network(getToken),
    store: new Store(new RecordSource()),
  })

export default environment
